// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MessageWrapper_wrapper__IdQfJ","error":"MessageWrapper_error__Q0LVw","success":"MessageWrapper_success__zMp9o"};